<div class="flex flex-column gap-4" [formGroup]="form" *ngIf="form">

    <p-accordion [multiple]="true" [activeIndex]="[0,1,2]" expandIcon="pi pi-chevron-down"
        collapseIcon="pi pi-chevron-up">

        <p-accordionTab header="International Rankings">
            <div class="formgrid grid">
                <!-- QS Ranking -->
                <div class="field col-12 md:col-6">
                    <label for="qsRanking" class="font-medium text-900 block mb-2">QS Ranking</label>
                    <input pInputText id="qsRanking" type="text" class="w-full" placeholder="e.g., 101-150"
                        formControlName="qsRanking" />
                    <div *ngIf="form.get('qsRanking')?.touched && form.get('qsRanking')?.invalid">
                        <small *ngIf="form.get('qsRanking')?.hasError('required')" class="p-error block mt-1">QS Ranking
                            is
                            required.</small>
                        <small *ngIf="form.get('qsRanking')?.hasError('pattern')" class="p-error block mt-1">Must be
                            valid
                            alphanumeric or range (e.g. 10, 91-100).</small>
                    </div>
                </div>

                <!-- US News Ranking -->
                <div class="field col-12 md:col-6">
                    <label for="usNewsRanking" class="font-medium text-900 block mb-2">US News Ranking</label>
                    <input pInputText id="usNewsRanking" type="text" class="w-full" placeholder="e.g., 85"
                        formControlName="usNewsRanking" />
                    <div *ngIf="form.get('usNewsRanking')?.touched && form.get('usNewsRanking')?.invalid">
                        <small *ngIf="form.get('usNewsRanking')?.hasError('pattern')" class="p-error block mt-1">Must be
                            valid alphanumeric or range (e.g. 85, 91-100).</small>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="National Rankings">
            <div class="formgrid grid">
                <!-- Country Ranking -->
                <div class="field col-12 md:col-6">
                    <label for="countryRanking" class="font-medium text-900 block mb-2">Country Ranking</label>
                    <input pInputText id="countryRanking" type="text" class="w-full" placeholder="e.g., 10"
                        formControlName="countryRanking" />
                    <div *ngIf="form.get('countryRanking')?.touched && form.get('countryRanking')?.invalid">
                        <small *ngIf="form.get('countryRanking')?.hasError('required')"
                            class="p-error block mt-1">Country
                            Ranking is required.</small>
                        <small *ngIf="form.get('countryRanking')?.hasError('pattern')" class="p-error block mt-1">Must
                            be valid alphanumeric or range.</small>
                    </div>
                </div>

                <!-- NIRF Ranking (India) — hidden from Admin Panel -->
                <!-- <div class="field col-12 md:col-4">
                    <label for="nirfRanking" class="font-medium text-900 block mb-2">NIRF Ranking (India)</label>
                    <input pInputText id="nirfRanking" type="text" class="w-full" placeholder="e.g., Rank 5"
                        formControlName="nirfRanking" />
                    <div *ngIf="form.get('nirfRanking')?.touched && form.get('nirfRanking')?.invalid">
                        <small *ngIf="form.get('nirfRanking')?.hasError('pattern')" class="p-error block mt-1">Must be
                            valid alphanumeric or range.</small>
                    </div>
                </div> -->

                <!-- India Today Ranking — hidden from Admin Panel -->
                <!-- <div class="field col-12 md:col-4">
                    <label for="indiaTodayRanking" class="font-medium text-900 block mb-2">India Today Ranking</label>
                    <input pInputText id="indiaTodayRanking" type="text" class="w-full" placeholder="e.g., Top 10"
                        formControlName="indiaTodayRanking" />
                    <div *ngIf="form.get('indiaTodayRanking')?.touched && form.get('indiaTodayRanking')?.invalid">
                        <small *ngIf="form.get('indiaTodayRanking')?.hasError('pattern')"
                            class="p-error block mt-1">Must
                            be valid alphanumeric or range.</small>
                    </div>
                </div> -->
            </div>
        </p-accordionTab>

        <p-accordionTab header="Specialized Rankings">
            <div class="flex flex-column gap-3">
                <label class="font-medium text-900 block">Subject Rankings</label>

                <div class="formgrid grid align-items-start" *ngFor="let row of subjectRanksRows.controls; let i = index"
                    [formGroup]="$any(row)">
                    <div class="field col-12 md:col-6 mb-2">
                        <input pInputText type="text" class="w-full" placeholder="Subject (e.g. Computer Science)"
                            formControlName="subject" />
                        <small *ngIf="row.get('subject')?.touched && row.get('subject')?.hasError('required')"
                            class="p-error block mt-1">Subject is required.</small>
                    </div>
                    <div class="field col-10 md:col-5 mb-2">
                        <input pInputText type="number" class="w-full" placeholder="Rank (e.g. 5)"
                            formControlName="rank" />
                        <small *ngIf="row.get('rank')?.touched && row.get('rank')?.hasError('required')"
                            class="p-error block mt-1">Rank is required.</small>
                        <small *ngIf="row.get('rank')?.touched && row.get('rank')?.hasError('pattern')"
                            class="p-error block mt-1">Rank must be a whole number.</small>
                    </div>
                    <div class="field col-2 md:col-1 mb-2 flex align-items-center justify-content-center">
                        <button type="button" pButton icon="pi pi-trash"
                            class="p-button-rounded p-button-text p-button-danger"
                            [disabled]="subjectRanksRows.length === 1" (click)="removeSubjectRank(i)"></button>
                    </div>
                </div>

                <div>
                    <button type="button" pButton icon="pi pi-plus" label="Add Subject Ranking"
                        class="p-button-text p-button-sm" (click)="addSubjectRank()"></button>
                </div>

                <small *ngIf="form.get('subjectRanks')?.touched && form.get('subjectRanks')?.hasError('required')"
                    class="p-error block">At least one subject ranking is required.</small>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Match Your Vibe!">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="chill" [binary]="true" inputId="chill"></p-checkbox>
                    <label for="chill" class="font-medium text-900 mb-0 cursor-pointer">Chill</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="competitive" [binary]="true" inputId="competitive"></p-checkbox>
                    <label for="competitive" class="font-medium text-900 mb-0 cursor-pointer">Competitive</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="startup" [binary]="true" inputId="startup"></p-checkbox>
                    <label for="startup" class="font-medium text-900 mb-0 cursor-pointer">Startup</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="research" [binary]="true" inputId="research"></p-checkbox>
                    <label for="research" class="font-medium text-900 mb-0 cursor-pointer">Research</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="creative" [binary]="true" inputId="creative"></p-checkbox>
                    <label for="creative" class="font-medium text-900 mb-0 cursor-pointer">Creative</label>
                </div>
                <div class="field col-12 md:col-4 flex align-items-center gap-3">
                    <p-checkbox formControlName="traditional" [binary]="true" inputId="traditional"></p-checkbox>
                    <label for="traditional" class="font-medium text-900 mb-0 cursor-pointer">Traditional</label>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

</div>